<template>
  <div class="macro">
    <el-tabs v-model="activeName">
      <!-- {{$attrs}} -->
      <el-tab-pane label="Search results" name="first">
        <macro-tab1 :lists="$attrs.lists" :total="$attrs.total" v-on="$listeners"></macro-tab1>
      </el-tab-pane>
      <el-tab-pane label="Index search" name="second">
        <macro-tab2></macro-tab2>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import MacroTab1 from "./macroTab1";
import MacroTab2 from "./macroTab2";
export default {
  props: {},

  components: {
    MacroTab1,
    MacroTab2
  },

  data() {
    return {
      activeName: "first"
    };
  },

  created() {},

  methods: {}
};
</script>

<style scoped>
.macro {
  height: 100%;
}
.macro >>> .el-tabs,
.macro >>> .el-tabs__content,
.macro >>> .el-tab-pane {
  height: 100% !important;
}
.macro >>> .el-tabs__content {
  height: 100% !important;
}
.macro >>> .el-tabs__nav-wrap::after {
  width: 0px !important;
}
.macro >>> .el-tabs__nav {
  width: 100% !important;
  background: #f7f8fa !important;
}
.macro >>> .el-tabs__nav .el-tabs__item {
  width: 50% !important;
  text-align: center;
}
.macro >>> .el-tabs__nav .is-active {
  background: #e2f0ff !important;
  color: #000000 !important;
  border-top: 2px solid #0078ff;
}
.macro >>> .el-tabs__active-bar {
  height: 0px !important;
}
</style>